import { IconButton, Text } from '@grupoboticario/flora-react';
import { theme, styled } from 'ui/theme';

export const SocialNetworksStyle = {
  Container: styled('div')`
    width: 100%;
    padding-top: 20px;
    border-top: 1px solid ${theme.colors.build.mediumLight2};
  `,

  Title: styled(Text)`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${theme.colors.build.mediumLight1};
  `,

  ButtonsContainer: styled('div')`
    display: flex;
    flex-direction: row;
    margin-top: 30px;
  `,

  SocialNetworkButton: styled(IconButton)`
    width: 78px;
    height: 90px;
    margin-right: 30px;
    padding: 0px;
  `,
};
